const authHeader = () => ({
  Authorization:
    'Basic ' +
    btoa(
      `${process.env.GATSBY_WP_USER_NAME}:${process.env.GATSBY_WP_USER_PASSWORD}`
    ),
});

export default authHeader;
